export default [{
  path: '/adaptation',
  name: 'adaptation',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/adaptation/index')
}]
